export const ignoredMessages = [
  'Script error.',
  "Cannot read property 'getCharacterList' of undefined", // @see https://github.com/facebook/draft-js/issues/1434
  'Second argument must be a string.', //@see https://github.com/facebook/draft-js/issues/2171
  "Cannot read properties of null (reading 'getFoldAt')",
  "Cannot read properties of undefined (reading 'getCharacterList')",
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
  "Cannot read property 'getEntity' of undefined",
  'Cannot read property getEntity of undefined/null expression',
  "Cannot read properties of undefined (reading 'getIn')", // there is a bug in draft-js,
  "TypeError Cannot read properties of undefined (reading 'getIn')",
  'Failed to fetch', // produced by clients code
  // Dexie internal errors
  /DatabaseClosedError.*/i,
  "Cannot read properties of undefined (reading 'getLength')",
  "TypeError: Cannot read properties of undefined (reading 'getInlineStyleAt')",
  /domFromPos/i,
]

export const extensionProtocols = [
  'chrome-extension://',
  'moz-extension://',
  'safari-web-extension://',
  'safari-extension://',
  'ms-browser-extension://',
  'edge-extension://',
]
